import { Component, OnInit } from '@angular/core';

import { Obrigacao } from "../shared/obrigacao.model";
import { ObrigacaoApiService } from "../shared/obrigacao-api.service";
import { Obrigacoeservice } from "../shared/obrigacao.service";
import { ObrigacaoNavigationService } from "../shared/obrigacao-navigation.service";
import { obrigacoesModuleName } from "../shared/data.service";
import { UtilService } from "../../../shared/services/util.service";
import { PessoaJuridicaApiService } from "../../../recursos-humanos/pessoa-juridica/shared/pessoa-juridica-api.service";

@Component({
  selector: 'app-obrigacao-list',
  template: require('./obrigacao-list.component.html'),
  styles: [require('./obrigacao-list.component.css')]
})
export class ObrigacaoListComponent implements OnInit {
  list: Obrigacao[] = [];
  loading: boolean = true;
  showDisabled: boolean = false;
  obrigacoesModuleName: any = obrigacoesModuleName;

  constructor(
    private _obrigacoesApiService: ObrigacaoApiService,
    private _obrigacoeservice: Obrigacoeservice,
    private _obrigacaoNavigationService: ObrigacaoNavigationService,
    private _pessoaJuridicaApiService: PessoaJuridicaApiService,
    private _utilService: UtilService
  ) { }

  ngOnInit() {
    this.getAll();
  }

  clickNew() {
    this._obrigacoeservice.clearSessionStorage();
    this._obrigacaoNavigationService.goToNew();
  }

  clickEdit(item: Obrigacao) {
    this._obrigacoeservice.clearSessionStorage();
    this._obrigacaoNavigationService.goToEdit(item.id);
  }

  clickDelete(item: Obrigacao) {
    var onDelete = (function() {
      this.onDelete(item);
    }.bind(this));

    this._utilService.swalMessageDelete(onDelete);
  }

  private getAll() {
    var onDone = (function(Response) {
      if (!Response.error)  {
        this.list = Response;
      }
      this.loading = false;
    }.bind(this));

    this._obrigacoesApiService.onGetAll(onDone);
  }

  private onDelete(item) {
    var onDone = (function (Response) {
      if (!Response.error) {
        var x: number, lenX: number;
        for (x = 0, lenX = this.list.length; x < lenX; x++) {
          if (this.list[x].id === item.id) {
            this.list[x].ativo = false;
            break;
          }
        }
        this._utilService.swalMessageDeleteSuccess();

        this.deletePessoaJuridica(item.pessoaJuridicaId);
      } else {
        this._utilService.swalMessageDeleteError();
      }
    }.bind(this));

    this._obrigacoesApiService.onDelete(item.id, onDone);
  }

  private deletePessoaJuridica(pessoJuridicaId:  number) {
    var onDone = (function (Response) {

    });

    this._pessoaJuridicaApiService.onDelete(pessoJuridicaId, onDone);
  }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/despachos/obrigacoes/obrigacao-list/obrigacao-list.component.ts
 **/